import React from "react"
import Switch from "@kiwicom/orbit-components/lib/Switch"
import Stack from "@kiwicom/orbit-components/lib/Stack"
import Text from "@kiwicom/orbit-components/lib/Text"

type Props = {
  feature: string
  onFeatureOverride: (featureName: string, newValue: boolean) => void
}

const FeatureToggle = ({ feature, onFeatureOverride }: Props) => {
  // @ts-expect-error: Flow to TS migration.
  const isChecked = window.__DARWIN__?.features?.[feature]

  const toggleFeature = React.useCallback(() => {
    onFeatureOverride(feature, !isChecked)
  }, [feature, onFeatureOverride, isChecked])

  return (
    <Stack direction="row" justify="between" align="center" spaceAfter="medium">
      <Text weight="bold">{feature}</Text>
      <Switch checked={isChecked} onChange={toggleFeature} />
    </Stack>
  )
}

export default FeatureToggle
